<script>
    export default {
        name: 'normal-radio',
        props: {
            value: {},
            label: {},
            disabled: Boolean,
            name: String,
            isUseDefaultLabel: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                focus: false
            };
        },
        computed: {
            model: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit('input', val);
                    this.$emit('change', val);
                }
            },
            isDisabled () {
                return this.disabled;
            }
        }
    };
</script>
<template>
    <label class="radio">
        <span class="radio-input"
              :class="{
                'is-disabled': isDisabled,
                'is-checked': model === label,
                'is-focus': focus
            }"
        >
            <span class="radio-inner"></span>
            <input
                    class="radio-original"
                    :value="label"
                    type="radio"
                    v-model="model"
                    @focus="focus = true"
                    @blur="focus = false"
                    :name="name"
                    :disabled="isDisabled">
        </span>
        <span class="el-radio__label" v-if="label || $slots.default">
            <slot></slot>
            <template v-if="!$slots.default && isUseDefaultLabel">{{label}}</template>
        </span>
    </label>
</template>

<style lang="less">
    @import '../../assets/less/widgets-var.less';

    .radio {
        color: #1f2d3d;
        position: relative;
        cursor: pointer;
        display: inline-block;
        white-space: nowrap;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        font-size: 14px;
    }

    .el-radio__label {
        font-size: 14px;
        padding-left: 10px;
    }

    .radio + .radio {
        margin-left: 15px
    }

    .radio-input {
        white-space: nowrap;
        cursor: pointer;
        outline: none;
        display: inline-block;
        line-height: 1;
        position: relative;
        vertical-align: middle
    }

    .radio-input.is-focus .radio-inner {
        border-color: @primaryBorderColor
    }

    .radio-input.is-checked .radio-inner {
        border-color: @primaryBorderColor;
        background: @primaryBg
    }

    .radio-input.is-checked .radio-inner:after {
        transform: translate(-50%, -50%) scale(1)
    }

    .radio-input.is-disabled .radio-inner {
        background-color: @otherDisabledBgClr;
        border-color: @otherBtnBorderNoteClr;
        cursor: not-allowed
    }

    .radio-input.is-disabled .radio-inner:after {
        cursor: not-allowed;
        background-color: @otherDisabledBgClr;
    }

    .radio-input.is-disabled .radio-inner + .radio-label {
        cursor: not-allowed
    }

    .radio-input.is-disabled.is-checked .radio-inner {
        background-color: #d1dbe5;
        border-color: @otherBtnBorderNoteClr
    }

    .radio-input.is-disabled.is-checked .radio-inner:after {
        background-color: #fff
    }

    .radio-input.is-disabled + .radio-label {
        color: #bbb;
        cursor: not-allowed
    }

    .radio-inner {
        border: 1px solid #bfcbd9;
        border-radius: 100%;
        width: 16px;
        height: 16px;
        background-color: #fff;
        position: relative;
        cursor: pointer;
        display: inline-block;
        box-sizing: border-box
    }

    .radio-inner:hover {
        border-color: @primaryBorderColor
    }

    .radio-inner:after {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #fff;
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(0);
        transition: transform .15s cubic-bezier(.71, -.46, .88, .6)
    }

    .radio-original {
        opacity: 0;
        outline: none;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
    }

    .radio-label {
        font-size: 14px;
        padding-left: 5px
    }

    .radio-group {
        display: inline-block;
        font-size: 0;
        line-height: 1;
        vertical-align: middle
    }

    .radio-group .radio {
        font-size: 14px
    }

    .radio-button {
        position: relative;
        display: inline-block
    }
</style>
